//TODO: convert these colors to foundry vars
export const selectStyles = {
  container: (provided, state) => ({
    ...provided,
    maxWidth: '20em',
    '+ label': {
      color: state.isDisabled
        ? '#92999D'
        : state.isFocused
        ? '#039de7'
        : '#414042',
      height: '1em',
      left: '1em',
      letterSpacing: '0.053em',
      background: '#ffffff',

      fontWeight: '600',
      fontSize: '0.8125em',
    },
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    paddingLeft: '1em',
  }),
  control: (provided, state) => ({
    ...provided,
    boxShadow: 'none',
    borderColor: state.isFocused ? '#039de7' : '#414042',
    borderRadius: '0.1875em',
    cursor: 'pointer',
    '&:hover': {
      borderColor: state.isFocused ? '#039de7' : '#414042',
    },
    height: '3.25em',
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    transition: 'color 150ms, transform 0.2s ease-in-out',
    padding: '0.75em',
    color: state.isFocused ? '#039de7' : '#414042',
    '&:hover': { color: state.isFocused ? '#039de7' : '#414042' },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  input: provided => ({
    ...provided,
    padding: '0.5em 1em',
    paddingLeft: '0',
  }),
  placeholder: (provided, state) => ({
    ...provided,
    left: '1em',
  }),
  menu: (provided, state) => ({
    ...provided,
    margin: '0',
    padding: '0',
  }),
  noOptionsMessage: (provided, state) => ({
    color: '#92999D',
    padding: '0.75em 1.25em',
  }),
  menuList: (provided, state) => ({
    ...provided,
    cursor: 'pointer',
  }),
  option: (provided, state) => ({
    ...provided,
    display: 'flex',
    width: '100%',
    padding: '0.25em 1em',
    color: '#414042',
    backgroundColor: '#ffffff',
    cursor: 'pointer',
    fontSize: '1em',
    lineHeight: '2em',
    '.field--content': {
      fontWeight: state.isSelected ? 'bold' : 'normal',
    },
    '.field--icon': {
      color: '#414042',
      width: '1.5em',
      paddingTop: '0.25em',
      marginRight: '0.5em',
    },
    ':hover': {
      backgroundColor: '#f0f0f0',
      color: '#414042',
      '.field--icon': {
        color: '#414042',
      },
    },
    ':active': {
      '.field--content': {
        fontWeight: 'bold',
      },
    },
  }),
}

export const altSelectStyles = {
  container: (provided, state) => ({
    ...provided,
    fontWeight: 400,
    marginRight: '1em',
    marginBottom: '0.5em',
    '&:firstChild': {
      marginLeft: '0',
    },
  }),
  control: (provided, state) => ({
    ...provided,
    boxShadow: 'none',
    borderWidth: '0 0 0.125em 0',
    borderStyle: 'solid',
    borderRadius: '0',
    borderColor: state.selectProps.menuIsOpen
      ? '#039DE7'
      : state.hasValue
      ? '#1682A2'
      : state.isFocused
      ? '#414042'
      : '#92999d',
    backgroundColor: 'transparent',
    cursor: state.selectProps.isDisabled ? 'not-allowed' : 'pointer',
    '&:hover': {
      borderColor: state.selectProps.menuIsOpen
        ? '#039DE7'
        : state.hasValue
        ? '#1682A2'
        : state.isFocused
        ? '#414042'
        : '#92999d',
    },
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    padding: '0',
    flexWrap: 'nowrap',
  }),
  singleValue: (provided, state) => ({
    ...provided,
    position: 'relative',
    transform: 'none',
    fontSize: '1.125em',
    lineHeight: '1.3125em',
    fontWeight: '400',
    minWidth: '100%',
    paddingRight: '0.25em',
    color: state.selectProps.menuIsOpen
      ? '#039DE7'
      : state.hasValue
      ? '#1682A2'
      : state.isFocused
      ? '#414042'
      : '#92999d',
  }),
  placeholder: (provided, state) => ({
    ...provided,
    position: 'relative',
    transform: 'none',
    fontSize: '1.125em',
    lineHeight: '1.3125em',
    fontWeight: '400',
    color: state.selectProps.menuIsOpen
      ? '#039DE7'
      : state.hasValue
      ? '#1682A2'
      : state.isFocused
      ? '#414042'
      : '#92999d',
    display: 'flex',
    flexWrap: 'nowrap',
    overflow: 'hidden',
    minWidth: '100%',
    whiteSpace: 'nowrap',
  }),
  indicatorsContainer: (provided, state) => ({
    ...provided,
    padding: '0',
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    padding: '0',
    color: state.selectProps.menuIsOpen
      ? '#039DE7'
      : state.hasValue
      ? '#1682A2'
      : state.isFocused
      ? '#414042'
      : '#92999d',
    transform: state.selectProps.menuIsOpen ? 'scaleY(-1)' : 'scaleY(1)',
    transition: 'transform 0.15s linear',
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  menu: (provided, state) => ({
    ...provided,
    marginTop: '0',
    minWidth: 'fit-content',
    whiteSpace: 'nowrap',
  }),
  menuList: (provided, state) => ({
    ...provided,
    paddingTop: '0',
    cursor: 'pointer',
  }),
  option: (provided, state) => ({
    ...provided,
    color: '#414042',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    fontSize: '1em',
    lineHeight: '2em',
    fontWeight: state.isSelected ? 'bold' : 'normal',
    '&:hover': {
      fontWeight: 'bold',
    },
    '&:active': {
      fontWeight: 'bold',
      backgroundColor: 'transparent',
    },
  }),
  groupHeading: (provided, state) => ({
    ...provided,
    color: '#92999D',
    fontSize: '1em',
    lineHeight: '2em',
  }),
}

export const editableSelectStyle = {
  ...selectStyles,
  container: (provided, state) => ({
    ...provided,
    marginBottom: '0.25em',
  }),
  menu: (provided, state) => ({
    ...provided,
    zIndex: 3,
  }),
  groupHeading: (provided, state) => ({
    ...provided,
    color: '#92999D',
    fontSize: '1em',
    lineHeight: '1.25em',
    textTransform: 'initial',
  }),
}
